import axiosInstance from './router/axiosInstance';
import { logger } from './logger';

// BUG-1: параметры шлём только ПАРОЙ — website.py фильтрует по смене лишь когда
// оба непустые, а одиночный/undefined параметр дал бы 422 (int-парсинг).
// encodeURIComponent: building_id приходит из useParams (percent-декодированный
// сегмент пути) — без энкодинга спецсимволы инжектились бы в query-строку.
function buildingFloorQuery(building_id, floor) {
  return building_id != null && floor != null
    ? `building_id=${encodeURIComponent(building_id)}&floor=${encodeURIComponent(floor)}`
    : '';
}

export default async function initializeEmployeesLocation(timestamp, building_id, floor) {
  try {
    const scope = buildingFloorQuery(building_id, floor);
    const { data: onlineWorkers } = await axiosInstance.get(`website/employees/online${scope ? `?${scope}` : ''}`);

    const responses = await Promise.allSettled(
      onlineWorkers.map(({ user_id }) => getLocationWorkerFromBuild(user_id, timestamp, building_id, floor))
    );

    return responses.filter((res) => res.status === 'fulfilled').map((res) => res.value);
  } catch (error) {
    // 404 от employees/online = «на этаже никого нет» — штатное состояние
    // (со скоупом по этажу это регулярный путь), не засоряем консоль каждые 5с.
    if (error?.response?.status !== 404) logger.error(error);
    return [];
  }
}

export async function getLocationWorkerFromBuild(user_id, timestamp, building_id, floor) {
  // BUG-1: без building_id+floor бэкенд отдаёт последнюю известную позицию из
  // ЛЮБОГО здания/этажа — на карте появлялись метки с чужого этажа.
  // Отказ (404 «нет смены на этом этаже») намеренно НЕ ловим здесь: вызывающий
  // Promise.allSettled отфильтровывает такие результаты.
  const scope = buildingFloorQuery(building_id, floor);
  return axiosInstance
    .get(
      `website/employee/coordinates/${user_id}?timestamp=${timestamp}${scope ? `&${scope}` : ''}`,
      {
        cache: false,
      }
    )
    .then((res) => {
      const data = res.data;
      return {
        ...data,
        user_id,
      };
    });
}
